import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { BaseUrl, RazorPayKey, RazorPayName, RazorPaySecretKey } from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import { QRCodeSVG } from 'qrcode.react';
import LazySection from "../../Pages/Home/LazySection";
import DeliveryTracker from "../DeliveryTracker/DeliveryTracker";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
const DarshanBookingOrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const { setLoader } = useContext(LoaderContext);
  const [localData, setLocalData] = useState(null);
  const [orders, setOrders] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)
  console.log("location?.state", location?.state);

  const handleProceedRemainingPayment = async () => {
    if (location.state.TRB_TOTALPRICE - location.state.TRANSACTION_AMT === 0) {
      alert("All the amount already paid");
      return;
    }
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    // let minPayableAmount = Remaining_Amount; // 20% of the total amount

    let orderIDReturned = location.state.TRB_ID;
    const finalAmount = Number(location.state.TRB_TOTALPRICE);
    const remainingAmount = location?.state?.RemainingAmount;
    const options = {
      key: RazorPayKey,
      key_secret: RazorPaySecretKey,
      amount: remainingAmount * 100,
      currency: "INR",
      name: RazorPayName,
      description: "working",
      image: Mylogo,
      handler: function (response) {
        // console.log(response, "Payment Success");
        const paymentId = response.razorpay_payment_id;

        if (response) {
          axios
            .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=Darshan`, {
              USER_ID: userID,
              ORDER_ID: orderIDReturned,
              // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
              TRANSACTION_ID: paymentId,
              PAYMENT_STATUS: "Success",
              TRANSACTION_STATUS: "Success",
              TRANSACTION_AMT: remainingAmount,
              REMAING_AMOUNT: 0,
              PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
            })
            .then((res) => {
              if (res.data.ResponseMessage === "successfully.") {
                // localStorage.setItem("cartItemCount", "0");
                // window.dispatchEvent(new Event("cartUpdated"));
                // setShowCODModal(false);
                // nextStep();
                navigate("/my-order-darshan-Booking");
              } else {
                alert("Order placement failed, please try again.");
              }
            });
        }

        // const updatedPayload = {
        //   ...razorPayData,
        //   TRANSACTION_ID: paymentId,
        //   TRANSACTION_AMT: minPayableAmount,
        // };

        // axios.post(`${BaseUrl}/BookPooja`, updatedPayload).then((res) => {
        //   debugger;
        //   if (res.data.ResponseMessage === "Order Success.") {
        //     localStorage.setItem("cartItemCount", "0");
        //     window.dispatchEvent(new Event("cartUpdated"));
        //     navigate("/thank-you");
        //   } else {
        //     alert("Order placement failed, please try again.");
        //   }
        // });
      },
      theme: {
        color: "#ff416c",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const myomnamoQRLink = location?.state?.TRB_ID;
  const trbId = location?.state?.TRB_QRCode;

  useEffect(() => {
    if (location?.state?.TRB_ID !== null && location?.state?.TRB_ID !== undefined && location?.state?.TRB_ID !== '') {
      GetOrderTrackingDetailsData()
    }
  }, [location])

  const handleDownloadInvoice = () => {
    const pdfUrl = location?.state?.InvoicePDFURL;
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    } else {
      console.error("PDF URL is not available");
    }
  };

  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetOrderTrackingDetails(userID, location?.state?.TRB_ID, 'Darshan'); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setOrderTrackingDetails(list[0])

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  const stepMap = [
    { key: "BookingDate", label: "Processed" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "CompletedDate", label: "Completed" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];
  return (
    <>
      <div className="m-5 p-5 my-4">
        <div className="row">
          {/* Left Section: Multiple Order Items */}
          <div className="col-md-8">
            <div className="card p-3 mb-3 shadow-sm">
              <div className="d-flex align-items-center">
                {/* Product Image on the Left */}
                <img
                  src={location?.state?.TR_IMAGE}
                  alt="Product"
                  className="rounded"
                  style={{
                    width: "180px",
                    height: "150px",
                    objectFit: "contain",
                  }}
                />

                {/* Product Details in the Center */}
                <div className="flex-grow-1 px-3">
                  <h4 className="fw-bold">{location?.state?.TR_NAME}</h4>
                  <hr />
                  {(location?.state?.TR_ADDRESS !== null && location?.state?.TR_ADDRESS !== undefined) && (
                    <p className=" mb-1">
                      <span className="fw-bold">Temple Address :</span>  {location?.state?.TR_ADDRESS}
                    </p>
                  )}

                  <p className=" mb-1">
                    <span className="fw-bold">Booking Date :</span>    {location?.state?.TRB_DATE}
                  </p>
                  <p className=" mb-1">
                    <span className="fw-bold"> Booking Time :</span>   {location?.state?.TTS_NAME}
                  </p>
                  <p className=" mb-1">
                    <span className="fw-bold"> Number Of Seats :</span>   {location?.state?.NO_SEATS}
                    {location?.state?.PersonDetails?.length > 0 && (
                      <table className="table table-bordered mt-2">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Visitor's Name</th>
                            <th>Age</th>
                            <th>Gender</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            <td>{1}</td>
                            <td>{templeBookingObj?.personName}</td>
                            <td>{templeBookingObj?.AGE}</td>
                            <td>{templeBookingObj?.GENDERID}</td>
                          </tr> */}
                          {location?.state?.PersonDetails?.map((value, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{value?.Name}</td>
                              <td>{value?.Age}</td>
                              <td>{value?.Gender}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}

                  </p>
                </div>

                {/* Price on the Right */}
                {/* <div className="text-end">
                  <h5 className="fw-bold  mb-0">
                    ₹{location?.state?.TRB_TOTALPRICE}
                  </h5>
                </div> */}
              </div>

            </div>

            {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

              <div >
                <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} /></LazySection>
              </div>
            )}
            <div>
              <p style={{ fontSize: "17px", fontWeight: "400" }}>
                When you are at temple, please scan below QR code to complete
                your darshan.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "30px",
                }}
              >
                {/* <QRCodeSVG value={location?.state?.TRB_ID} /> */}
                {location?.state?.TRB_QRCode ? (
                  <QRCodeSVG value={trbId.toString()} />
                ) : (
                  <p>TRB_ID is not available.</p>
                )}

                {/* <QRCodeCanvas
                  value={`${myomnamoQRLink}`}
                  size={150}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"
                /> */}
              </div>
            </div>
          </div>

          {/* Right Section: Single Product's Shipping & Price Details */}
          <div className="col-md-4">


            <div className="card p-3 shadow-sm">
              <h4 className="fw-bold">Price Details</h4>
              <hr />
              <div className="d-flex justify-content-between">
                <p className=" fw-bold">Price per person (₹) : </p>
                <p >{location?.state?.TRB_PRICE}</p>
              </div>
              {location?.state?.CouponCodeAmount !== 0 ? (
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">
                    Coupon Amount (₹) :
                  </p>
                  <p >
                    {location?.state?.CouponCodeAmount}
                  </p>
                </div>
              ) : location?.state?.WalletAmount !== 0 ?
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">
                    Wallet Amount (₹) :
                  </p>
                  <p  >
                    {location?.state?.WalletAmount}
                  </p>
                </div> : ''}
              <div className="d-flex justify-content-between">
                <p className=" fw-bold">Total Seats :</p>
                <p >{location?.state?.NO_SEATS}</p>
              </div>

              <div className="d-flex justify-content-between">
                <p className="fw-bold"> Convenience Fee (₹) : </p>
                <p >
                  {Math.round(Number(location?.state?.Convinience_Fee) + Number(location?.state?.ConvinienceFeeTaxAmount))}
                </p>
              </div>
              <hr></hr>
              {/* <div className="d-flex justify-content-between">
                <p className="fw-bold">Total Amount (₹)</p>
                <p className=" fw-bold">
                  <span>  {Number(location?.state?.TRB_PRICE) * Number(location?.state?.NO_SEATS) + Number(location?.state?.Convinience_Fee)}</span>
                </p>
              </div> */}
              {/* <div className="d-flex justify-content-between">
                <p className="fw-bold">Tax ({location?.state?.Tax_Perc}%)</p>
                <p className=" fw-bold">
                  <span>
                    {location?.state?.Tax_Amount}

                  </span>
                </p>
              </div> */}
              <div className="d-flex justify-content-between">
                <p className="fw-bold">Grand Total (₹)</p>
                <p >

                  {Number(location?.state?.TRB_TOTALPRICE)}

                </p>
              </div>
            </div>

            {location?.state?.RemainingAmount == 0 && (
              <button
                className="careox-btn mt-2"
                onClick={() => handleDownloadInvoice(location?.state?.TRB_ID)}
              >
                Download Invoice
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DarshanBookingOrderDetails;
